// extracted by mini-css-extract-plugin
export default {"item":"ClientLogos_item__8f7Fh","logo":"ClientLogos_logo__ByS97"};